__webpack_require__.p = "/frenzy-go/";